import {
    type ColorRush,
    type FastLaneStyle,
    DisplayType,
    FastLaneInstance,
    FastLaneSection,
    ThemeConfig,
    WaveDirection,
} from '../types';
import {get, set} from "./index";

export interface InitializeState {
    initialize: (initializeParams: InitializeParams) => void;
    initializeInstance: (initializeParams: FastLaneInstance, display: DisplayType) => void;
}

interface InitializeParams {
    isEditor: boolean;
    entries: Array<FastLaneSection>;
    theme: ThemeConfig;
    style?: FastLaneStyle;
    debugMode?: boolean;
    colorRush?: ColorRush;
    waveDirection?: WaveDirection;
    languages?: Array<string>
    takeoverSectionWidths?: Array<{
        index: number;
        width: number;
    }>
}

export const initializeState = (set: set, get: get): InitializeState => ({
    initialize: ({isEditor, debugMode, colorRush, waveDirection, entries, theme, languages, takeoverSectionWidths, style}) => {
        set({
            isEditor,
            entries,
            theme,
            style: style ?? get().style,
            waveDirection: waveDirection ?? get().waveDirection,
            colorRush: colorRush ?? get().colorRush,
            debugMode: debugMode ?? get().debugMode,
            languages: languages ?? [],
            takeoverSectionWidths: takeoverSectionWidths ?? [],
        });
        get().addIndexToEntries();
    },

    initializeInstance: ({isEditor = false, entries, theme, waveDirection, colorRush, languages, pixelMap, takeoverSectionWidths, style}: FastLaneInstance) => {
        get().initialize({
            isEditor,
            entries,
            theme,
            waveDirection,
            colorRush,
            languages,
            takeoverSectionWidths,
            style,
        });
    }
});
